import $ from 'jquery'

const DATA_VALUES = 'values'
const DATA_AUTOSUBMIT = 'autosubmit'
const ITEM_CSS_CLASS = 'autocomplete-result__item'
const ITEM_NORESULTS_CSS_CLASS = 'autocomplete-result__item--no-results'

class Autocompletes {
  constructor(selector = '.autocomplete') {
    this.items = $(selector)

    this.init()
  }

  init() {
    this.items.each((index, item) => new Autocomplete(item))
  }
}

class Autocomplete {
  constructor(el) {
    this.el = $(el)
    this.input = $('input', el)
    this.list = $('.autocomplete-result', el)
    this.reset = $('.autocomplete-reset', el)
    this.listItems = null
    this.value = this.input.val()
    this.matches = 0

    this.values = this.input.data(DATA_VALUES) || []
    this.autosubmit = Boolean(this.input.data(DATA_AUTOSUBMIT)) || false
    this.noResultsText = 'Keine Ergebnisse'
    this.init()
  }

  init() {
    this.setInitialResetState()
    this.listen()
  }

  listen() {
    this.input.on('input', this.onInputChanged.bind(this))
    this.input.on('keydown', this.onKeyDown.bind(this))
    this.input.on('focus', this.onInputFocus.bind(this))
    this.input.on('blur', this.onInputBlur.bind(this))
    this.reset.on('click', this.onResetClick.bind(this))

    this.el.on('mousedown', '.' + ITEM_CSS_CLASS, this.onItemClick.bind(this))
  }

  onInputChanged() {
    this.value = this.input.val().trim()

    if (!this.value.length) {
      return this.hideList()
    }

    this.updateList()
    this.showList()
  }

  onKeyDown(e) {
    if (e.keyCode === 13) {
      e.preventDefault()
      this.setFirstItemAsValue()
    }

    return e
  }

  onInputFocus() {
    if (!this.value.length) {
      return
    }
    this.updateList()
    this.showList()
  }

  onInputBlur() {
    this.hideList()
  }

  onItemClick(e) {
    const item = $(e.target)
    this.setItemAsValue(item)
  }

  onResetClick() {
    this.value = ''
    this.input.val('')

    if (!this.autosubmit) {
      return
    }

    this.el.closest('form').trigger('submit')
  }

  setInitialResetState() {
    if (!this.value.length) {
      return
    }

    this.reset.show()
  }

  setFirstItemAsValue() {
    const item = $('.' + ITEM_CSS_CLASS, this.list).first()
    this.setItemAsValue(item)
  }

  setItemAsValue(item) {
    const value = item.text().trim()
    if (item.hasClass(ITEM_NORESULTS_CSS_CLASS)) {
      return this.hideList()
    }

    this.value = value
    this.input.val(value)

    if (!this.autosubmit) {
      return
    }

    this.el.closest('form').trigger('submit')
  }

  showList() {
    this.list.slideDown('fast')
  }

  hideList() {
    this.list.slideUp('fast')
  }

  updateList() {
    this.list.empty()
    const query = new RegExp('^' + this.value, 'gi')
    let count = 0
    this.values.forEach(value => {
      const match = value.match(query)
      if (!match) {
        return
      }

      this.createListItem(value, match[0])
      count += 1
    })

    this.matches = count

    if (count) {
      return
    }

    this.createNoResults()
  }

  createListItem(value, matched) {
    const item = `<div class="${ITEM_CSS_CLASS}">
      <span>${matched}</span>${value.substring(matched.length)}
    </div>`

    this.list.append(item)
  }

  createNoResults() {
    const item = `<div class="autocomplete-result__item autocomplete-result__item--no-results">
      ${this.noResultsText}
    </div>`

    this.list.append(item)
  }
}

export default Autocompletes
